import { render, staticRenderFns } from "./user-details-header.vue?vue&type=template&id=0cf96d3d&lang=pug&"
import script from "./user-details-header.vue?vue&type=script&lang=js&"
export * from "./user-details-header.vue?vue&type=script&lang=js&"
import style0 from "./user-details-header.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports